var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { alloweds, isTypeHasntLabel } from "./utils/elementsUtils";
import { isDateValid, toDateString, formatDateStringToISO } from "./utils/dateUtils";

export var formToJSONSchema = function formToJSONSchema() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var schema = {
    type: "object",
    properties: {},
    required: []
  };
  var _form$elements = form.elements,
      elements = _form$elements === undefined ? [] : _form$elements;


  return elements.reduce(function (newSchema, section) {
    var elements = section.elements;

    var sectionProperties = elements.filter(function (field) {
      return alloweds.includes(field.type);
    }).reduce(function (previousFields, field) {
      var key = field.key,
          title = field.title,
          type = field.type,
          readonly = field.readonly,
          titleMap = field.titleMap,
          mappingName = field.mappingName,
          mappingValue = field.mappingValue,
          operation = field.operation,
          service = field.service,
          required = field.required;


      previousFields[key] = {
        title: title,
        type: "string",
        metadata: _extends({}, field)
      };

      if (type === "radios" && titleMap) {
        previousFields[key].enum = titleMap.map(function (object) {
          return "" + object.value;
        });
        previousFields[key].enumNames = titleMap.map(function (object) {
          return "" + object.name;
        });
      }

      if (type === "checkboxes" && titleMap) {
        previousFields[key].type = "array";
        previousFields[key].items = {
          type: "string",
          enum: titleMap.map(function (object) {
            return "" + object.value;
          }),
          enumNames: titleMap.map(function (object) {
            return "" + object.name;
          })
        };
        previousFields[key].uniqueItems = true;
      }

      if (type === "file-multiple") {
        previousFields[key].type = "array";
        previousFields[key].items = {
          type: "object",
          properties: {
            name: { type: "string" },
            id: { type: "string" },
            type: { type: "string" },
            length: { type: "number" },
            originalFileName: { type: "string" },
            link: { type: "string" },
            displayName: { type: "string" }
          }
        };
      }

      if (type === "select" && titleMap) {
        previousFields[key].items = {
          type: "array",
          titleMap: titleMap
        };
      }

      if (type === "table-editable") {
        previousFields[key].type = "array";
        previousFields[key].elements = field.elements;
      }

      if (type === "link") {
        previousFields[key].path = field.path;
      }

      if (type === "paragraph") {
        previousFields[key].text = field.text;
      }

      if (type === "mask") {
        previousFields[key].mask = field.mask;
      }

      if (type === "input-number") {
        previousFields[key].type = "number";
      }

      if (type === 'location') {
        previousFields[key].type = 'object';
        previousFields[key].required = previousFields[key].metadata.required ? ['x', 'y', 'epsgCode'] : [];
        previousFields[key].properties = {
          x: { type: 'number', metadata: {} },
          y: { type: 'number', metadata: {} },
          epsgCode: { type: 'string', metadata: {} }
        };
      }

      if (field.required) {
        schema.required.push(key);
      }

      return previousFields;
    }, {});

    return _extends({}, newSchema, {
      properties: _extends({}, newSchema.properties, sectionProperties)
    });
  }, schema);
};

export var formToUISchema = function formToUISchema() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var environment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _form$elements2 = form.elements,
      elements = _form$elements2 === undefined ? [] : _form$elements2;


  return elements.reduce(function (uiSchema, section, indice) {
    var elements = section.elements;


    var schemaProperties = elements.filter(function (field) {
      return alloweds.includes(field.type);
    }).reduce(function (previousFields, field) {
      var key = field.key,
          type = field.type,
          cols = field.cols;

      var fieldProps = {};

      if (cols) {
        var _ref;

        var sectionLayoutArray = uiSchema["ui:layout"][indice] || [];
        uiSchema["ui:layout"][indice] = [].concat(sectionLayoutArray, [(_ref = {}, _ref[key] = Number(cols), _ref)]);
      }

      if (type === "textarea") {
        fieldProps["ui:widget"] = "textarea";
      }

      if (type === "input-date") {
        fieldProps["ui:widget"] = "dateWidget";
      }

      if (type === "input-number") {
        fieldProps["ui:widget"] = "number";
      }

      //TOOD: pegar todos os titulos
      if (["h1", "h2", "h3", "h4"].includes(type)) {
        fieldProps["ui:widget"] = "titleWidget";

        var uiOptions = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, uiOptions, {
          titleType: type
        });
      }

      if (type === "radios") {
        fieldProps["ui:widget"] = "radio";
      }

      if (type === "checkboxes") {
        fieldProps["ui:widget"] = "checkboxes";

        var _uiOptions = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions, {
          addable: false,
          orderable: false,
          removable: false
        });
      }

      if (type === "file-multiple") {
        var upload = environment.upload,
            headers = environment.headers;


        fieldProps["ui:widget"] = "file-multiple";

        var _uiOptions2 = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions2, {
          addable: false,
          orderable: false,
          removable: false,
          upload: upload,
          headers: headers
        });
      }

      if (type === "rich-text") {
        fieldProps["ui:widget"] = "richTextWidget";
      }

      if (type === "select") {
        var _headers = environment.headers,
            disableOnLoadIntegration = environment.disableOnLoadIntegration;

        fieldProps["ui:widget"] = "select";

        var _uiOptions3 = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions3, {
          headers: _headers,
          disableOnLoadIntegration: disableOnLoadIntegration
        });
      }

      if (type === "table-editable") {
        var _headers2 = environment.headers,
            _disableOnLoadIntegration = environment.disableOnLoadIntegration;

        fieldProps["ui:widget"] = "table-editable";

        var _uiOptions4 = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions4, {
          headers: _headers2,
          disableOnLoadIntegration: _disableOnLoadIntegration
        });
      }

      if (type === "link") {
        fieldProps["ui:widget"] = "link";
      }

      if (type === "location") {
        fieldProps["ui:widget"] = "location";
      }

      if (type === "paragraph") {
        fieldProps["ui:widget"] = "paragraph";
      }

      if (type === "mask") {
        fieldProps["ui:widget"] = "mask";
      }

      if (type === "input-cpf") {
        fieldProps["ui:widget"] = "input-cpf";
      }

      if (type === "input-cnpj") {
        fieldProps["ui:widget"] = "input-cnpj";
      }

      if (type === "input-decimal") {
        fieldProps["ui:widget"] = "input-decimal";
      }

      if (isTypeHasntLabel(type)) {
        var _uiOptions5 = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions5, { label: false });
      }

      if (environment.customProps && environment.customProps[type]) {
        var customProps = environment.customProps[type];

        var _uiOptions6 = fieldProps["ui:options"];
        fieldProps["ui:options"] = _extends({}, _uiOptions6, {
          customProps: customProps
        });
      }

      previousFields[key] = fieldProps;

      return previousFields;
    }, {});

    return _extends({}, uiSchema, schemaProperties);
  }, { "ui:layout": [] });
};

export var formDefaultValues = function formDefaultValues() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _form$elements3 = form.elements,
      elements = _form$elements3 === undefined ? [] : _form$elements3;


  return elements.reduce(function (newSchema, section) {
    var elements = section.elements;


    var schemaProperties = elements.reduce(function (previousFields, field) {
      var key = field.key,
          type = field.type,
          valueDefault = field.valueDefault;


      if (!valueDefault) {
        return previousFields;
      }

      var value = valueDefault;

      if (type === "checkboxes") {
        value = valueDefault.split(",");
      }

      if (type === "input-date") {
        value = formatDateStringToISO(valueDefault);
      }

      previousFields[key] = value;

      return previousFields;
    }, {});

    return _extends({}, newSchema, schemaProperties);
  }, {});
};

export var formDataValues = function formDataValues() {
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var parsed = _extends({}, formData);

  for (var _iterator = Object.keys(formData), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var key = _ref2;

    var value = formData[key];
    var isString = isNaN(value) && typeof value === "string";

    if (!isString || !isDateValid(value)) {
      continue;
    }

    parsed[key] = formatDateStringToISO(value, "L", "pt-br");
  }

  return parsed;
};

export var exportFormDataValeus = function exportFormDataValeus() {
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var parsed = _extends({}, formData);

  for (var _iterator2 = Object.keys(formData), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref3 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref3 = _i2.value;
    }

    var key = _ref3;

    var value = formData[key];
    var isString = isNaN(value) && typeof value === "string";

    if (!isString || !isDateValid(value)) {
      continue;
    }

    parsed[key] = value;
  }

  return parsed;
};